import React, { useState, useEffect, useMemo } from 'react';
import { Container, Row, Col, Card, Button, ListGroup, Image, Spinner, Form, InputGroup, Badge, Toast } from 'react-bootstrap';
import { toast } from "react-toastify";
import { useSelector, useDispatch } from 'react-redux';
import { data, useNavigate } from "react-router-dom";
import { getCartItems, removeItemFromCart, increaseQuantity, decreaseQuantity, clearCart } from '../../../redux/cartSlice';
import { placeOrder } from '../../../redux/orderSlice';
import ApplyCouponForm from "../ApplyCoupon/ApplyCoupon";
import { applyCoupon, clearCoupon } from "../../../redux/couponSlice";
import { addAddress, getAllAddress, updateAddress, deleteAddress, clearError } from "../../../redux/addressSlice";
import useUserLocation from "../../Hooks/useUserLocation";
import { FaHome, FaBuilding, FaPen, FaTrash } from "react-icons/fa";
import { AiFillCloseCircle } from "react-icons/ai";
import RazorpayButton from "../RazorpayButton/RazorpayButton";
import AddressModal from '../../common/Modal/AddressModal/AddressModal';

const Address = () => {

  const apiUrl = process.env.REACT_APP_API_URL;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isAdding, setIsAdding] = useState(false);
  const { cartItems, totalAmount, loading: cartLoading, error: cartError } = useSelector((state) => state.cart);
  const { addressItems, loading: addressLoading, error: addressError } = useSelector((state) => state.address);
  const [userCouponCode, setUserCouponCode] = useState("");
  const [cartTotalAmount, setCartTotalAmount] = useState(totalAmount);
  const [storeCode, setStoreCode] = useState(null);
  const [storeDisconunt, setStoreDiscount] = useState(null);
  if (process.env.NODE_ENV === "development") {
    console.log("userCouponCode cart+++", userCouponCode);
  }
  const { coordinates, address, loading: locationLoading, error: locationError } = useUserLocation();
  // const [selectedAddress, setSelectedAddress] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(() =>
    addressItems && addressItems.length > 0 ? addressItems[0]._id : null
  );
  if (process.env.NODE_ENV === "development") {
    console.log("selectedAddress", selectedAddress);
  }
  const [modalShow, setModalShow] = useState(false);
  const [updateAddressId, setUpdateAddressId] = useState(null);

  const getUserCouponCode = (data) => {
    if (process.env.NODE_ENV === "development") {
      console.log("data+++++++++++", data);
    }
    setUserCouponCode(data);
    setStoreCode(data.couponCode);
    setStoreDiscount(data.discount);
  }

  const handleRemove = (productId) => {
    if (process.env.NODE_ENV === "development") {
      console.log("productId", productId);
    }
    dispatch(removeItemFromCart(productId));
  };

  const handleIncreaseQuantity = (e, productId) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(increaseQuantity(productId));
    // dispatch(applyCoupon({ code: storeCode, cartTotal: totalAmount }))
  };

  const handleDecreaseQuantity = (e, productId) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(decreaseQuantity(productId));
    // dispatch(applyCoupon({ code: storeCode, cartTotal: totalAmount }))
  };

  const handlePlaceOrder = async () => {
    try {
      setIsAdding(true);
      const orderData = {
        products: cartItems.map((item) => ({
          product: item.product._id,
          quantity: item.quantity,
        })),
        paymentMethod: "COD",
        couponCode: userCouponCode.couponCode
      };

      await dispatch(placeOrder(orderData));
      toast.success("Order placed successfully!");
      dispatch(clearCart());
      setIsAdding(false);
      navigate("/my/order");
    } catch (error) {
      toast.error("Failed to place order.");
    }
  };

  useEffect(() => {
    dispatch(getCartItems());
  }, [dispatch, totalAmount]);

  useEffect(() => {
    dispatch(getAllAddress()).then((res) => {
      toast.success(res.payload.message);
    });
  }, [dispatch]);

  useEffect(() => {
    if (addressItems?.length > 0) {
      const defaultAddr = addressItems.find(addr => addr?.isDefault);
      setSelectedAddress(defaultAddr?._id);
    }
  }, [addressItems]);



  const finalAmount = useMemo(() => {
    if (userCouponCode?.discount > 0) {
      return userCouponCode?.finalAmount || (totalAmount - userCouponCode.discount);
    }
    return totalAmount;
  }, [userCouponCode, totalAmount]);

  { cartLoading && <p>Loading cart items...</p> }
  { cartError && <p className="text-red-500">Error: {cartError}</p> };

  const handleSave = (data) => {
    if (process.env.NODE_ENV === "development") {
      console.log('Saved Address Page:', data);
    }
    dispatch(addAddress(data)).then((res) => {
      if (res) {
        dispatch(getAllAddress());
        toast.success(res);
      }
    });
    dispatch(clearError());
  };

  const handleEdit = (address) => {
    console.log('Edit Address:', address);
    setUpdateAddressId(address);  // full object
    setModalShow(true);
    dispatch(clearError());
  };

  const handleUpdate = async (formData) => {
    if (process.env.NODE_ENV === "development") {
      console.log('Updated Address123', selectedAddress, formData);
    }
    await dispatch(updateAddress({ id: selectedAddress, updatedData: formData })).then((res) => {
      if (res) {
        dispatch(getAllAddress());
        toast.success(res.payload.message);
      }
    });
    dispatch(clearError());
  };

  const handleDelete = async (id) => {
    if (process.env.NODE_ENV === "development") {
      console.log('Updated Delete', id);
    }
    dispatch(deleteAddress(id)).then((res) => {
      if (res) {
        toast.success(res.payload.message);
        dispatch(getAllAddress());
      }
    });
    dispatch(clearError());
  };


  return (
    <>
      <AddressModal
        show={modalShow}
        handleClose={() => setModalShow(false)}
        handleSave={handleSave}
        updateAddressId={updateAddressId}
        handleUpdate={handleUpdate}
      />
      <Container className="mt-5">
        {cartItems.length === 0 ? (
          <p className="text-center">Your cart is empty.</p>
        ) : (
          <>
            <Row>
              <Col xl={{ span: 10, offset: 1 }}>
                <Row>

                  <Col xl={8} lg={8} sm={12} md={7} xs={12}>
                    <Container>
                      <Row>
                        <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                          <h6>Select Delivery Address</h6></Col>
                        <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                          <Button variant="default-primary" className="mb-2 fw-bold float-end text-uppercase text-decoration-underline" onClick={() => setModalShow(true)}>Add New Address</Button>
                        </Col>
                      </Row>
                      <Row>
                        <Col xl={12} lg={12} sm={12} md={12} xs={12}>
                          {addressItems.length > 0 && <h6>Default Address</h6>}
                          {addressItems && addressItems?.filter(a => a?.isDefault === true).map(addr => (
                            <Card className="p-3 mb-3" key={addr._id} name="address">
                              <Form.Check
                                type="radio"
                                name="address"
                                checked={selectedAddress === addr._id}
                                onChange={() => setSelectedAddress(addr._id)}
                                label={
                                  <div>
                                    <strong>{addr.fullName}</strong> <Badge bg="light" text="dark">{addr?.addressType}</Badge>
                                    <div>{addr.address}</div>
                                    <div><strong>Mobile:</strong> {addr.mobileNumber}</div>
                                  </div>
                                }
                              />
                              <div className="mt-2">
                                <Button variant="secondary" size="sm" className="me-2" onClick={() => handleDelete(addr._id)}>Remove</Button>
                                <Button variant="outline-primary" size="sm" onClick={() => handleEdit(addr)}>Edit</Button>
                              </div>
                            </Card>
                          ))}

                          {addressItems.length > 0 && <h6>Home Address</h6>}
                          {addressItems && addressItems?.filter(a => a?.addressType === "Home").map(addr => (
                            <Card className="p-3 mb-3" key={addr?._id} name="address">
                              <Form.Check
                                type="radio"
                                name="address"
                                checked={selectedAddress === addr?._id}
                                onChange={() => setSelectedAddress(addr?._id)}
                                label={
                                  <div>
                                    <strong>{addr?.fullName}</strong> <Badge bg="light" text="dark">{addr?.addressType}</Badge>
                                    <div>{addr?.address}</div>
                                    <div><strong>Mobile:</strong> {addr?.mobileNumber}</div>
                                    {addr?.cod && <div className="text-muted">• Pay on Delivery available</div>}
                                  </div>
                                }
                              />
                              <div className="mt-2">
                                <Button variant="secondary" size="sm" className="me-2" onClick={() => handleDelete(addr?._id)}>Remove</Button>
                                <Button variant="outline-primary" size="sm" onClick={() => handleEdit(addr)}>Edit</Button>
                              </div>
                            </Card>
                          ))}

                          {addressItems.length > 0 && <h6>Other Address</h6>}
                          {addressItems && addressItems?.filter(a => a?.addressType !== "Home").map(addr => (
                            <Card className="p-3 mb-3" key={addr?._id} name="address">
                              <Form.Check
                                type="radio"
                                name="address"
                                checked={selectedAddress === addr?._id}
                                onChange={() => setSelectedAddress(addr?._id)}
                                label={
                                  <div>
                                    <strong>{addr?.fullName}</strong> <Badge bg="light" text="dark">{addr?.addressType}</Badge>
                                    <div>{addr?.address}</div>
                                    <div><strong>Mobile:</strong> {addr?.mobileNumber}</div>
                                    {addr?.cod && <div className="text-muted">• Pay on Delivery available</div>}
                                  </div>
                                }
                              />
                              <div className="mt-2">
                                <Button variant="secondary" size="sm" className="me-2" onClick={() => handleDelete(addr?._id)}>Remove</Button>
                                <Button variant="outline-primary" size="sm" onClick={() => handleEdit(addr)}>Edit</Button>
                              </div>
                            </Card>
                          ))}
                          <Button variant="outline-danger" className="w-100" onClick={() => setModalShow(true)}>+ Add New Address</Button>
                        </Col>
                      </Row>
                    </Container>
                  </Col>

                  <Col xl={4} lg={4} sm={12} md={5} xs={12}>
                    <Card className="p-3 shadow-sm">
                      <h4>Order Summary</h4>
                      {/* <p>Total Items: {cartItems.length}</p> */}
                      <p>Price Details ({cartItems.length} Items)</p>

                      <ApplyCouponForm
                        cartTotal={totalAmount}
                        getUserCouponCode={getUserCouponCode}
                      />

                      <h6 className="d-flex justify-content-between">Total Product Price: <span>₹{totalAmount.toFixed(2)}</span></h6>
                      {/* <h5 className="d-flex justify-content-between">Total Discount Price: <span>₹{totalAmount.toFixed(2)}</span></h5> */}
                      <h6 className="d-flex justify-content-between">Shipping<span>Free</span></h6>
                      {userCouponCode.discount > 0 && <h5 className="d-flex justify-content-between">Total Discounts: <span>-₹{userCouponCode.discount}</span></h5>}
                      {userCouponCode.discount < 0 && <h5 className="d-flex justify-content-between">Order Total 1 : <span>₹{userCouponCode?.finalAmount?.toFixed(2)}</span></h5>}
                      {userCouponCode.discount && !userCouponCode.discount > 0 && <h5 className="d-flex justify-content-between">Order Total 2: <span>₹{totalAmount.toFixed(2)}</span></h5>}
                      <h6 className="d-flex justify-content-between">Order Total : <span>₹{finalAmount.toFixed(2)}</span></h6>

                      <Button variant="success" className="mt-3 w-100" onClick={handlePlaceOrder} disabled={isAdding}>
                        {isAdding ? 'Proceed...' : 'Proceed to Checkout'}
                      </Button>
                      <hr />
                      <Card>
                        <RazorpayButton amount={finalAmount} />
                      </Card>
                      <div className="user-location">
                        {/* <h2>My Location:</h2> */}
                        {locationLoading && <p>Loading location...</p>}
                        {locationError && <p style={{ color: "red" }}>Error: {locationError}</p>}
                        {!locationLoading && !locationError && (
                          <>
                            {/* <p>
                        <strong>Coordinates:</strong> {coordinates.lat}, {coordinates.lng}
                      </p> */}
                            <p>
                              <strong>Address:</strong> {address}
                            </p>
                          </>
                        )}
                        <hr />
                        <div className="change-location">
                          <h5>Change Location</h5>
                          <InputGroup className="mt-3 mb-3">
                            <Button variant="success">Detect my location</Button>
                            <InputGroup.Text>OR</InputGroup.Text>
                            <Form.Control placeholder="Search delivery location" />
                          </InputGroup>
                        </div>
                        <hr />
                        <h5>Your saved addresses</h5>

                      </div>
                    </Card>

                  </Col>
                </Row>
              </Col>
            </Row>
          </>
        )}
      </Container >
    </>
  );
};

export default Address;
